import { jsxs as L, jsx as t } from "react/jsx-runtime";
import { InputGroup as w, InputLeftElement as A, InputLeftAddon as B, Divider as l, Input as S, InputRightElement as W, InputRightAddon as k } from "@chakra-ui/react";
import { forwardRef as b } from "react";
import j from "../SearchInput/SearchButton.mjs";
const y = b((u, h) => {
  const {
    inputLeftAddon: e,
    inputRightAddon: n,
    inputLeftElement: o,
    inputLeftElementOverride: p,
    inputRightElement: d,
    inputRightElementOverride: a,
    maxW: m,
    maxWidth: s,
    minW: c,
    minWidth: f,
    onSearchClick: g,
    size: x = "md",
    showSearchButton: v = !1,
    type: i,
    variant: r = "outline",
    w: E,
    width: I,
    ...R
  } = u;
  return /* @__PURE__ */ L(
    w,
    {
      size: x,
      variant: r,
      w: E,
      width: I,
      maxW: m,
      maxWidth: s,
      minW: c,
      minWidth: f,
      ...i === "search" && {
        sx: {
          ":has(input.chakra-input:focus)": {
            boxShadow: "outline",
            borderRadius: "lg"
          }
        }
      },
      children: [
        o && !p && /* @__PURE__ */ t(A, { pointerEvents: "none", children: o }),
        p,
        e && /* @__PURE__ */ t(B, { children: e }),
        e && r === "filled" && /* @__PURE__ */ t(l, { orientation: "vertical", marginLeft: "-1px" }),
        /* @__PURE__ */ t(S, { ref: h, type: i, ...R }),
        d && !a && /* @__PURE__ */ t(W, { pointerEvents: "none", children: d }),
        a,
        n && r === "filled" && /* @__PURE__ */ t(l, { orientation: "vertical", marginRight: "1px" }),
        n && /* @__PURE__ */ t(k, { children: n }),
        i === "search" && v && /* @__PURE__ */ t(j, { onClick: g })
      ]
    }
  );
});
y.displayName = "InputBase";
export {
  y as InputBase
};
